// Dev deployment URLs for klaro-shell. Hosts derived from
// values-dev.yml KLARO_*_SERVICE_OPENAPI_SERVER_URL entries
// (zube-infra/apps-helm-charts/<svc>/<svc>/values-dev.yaml). Each
// {service}ServiceUrl is base + dev context-path; service code appends
// the API path (e.g. `/api/v1/...`).
import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  envName: 'dev',
  // Catalogue apps are gated by their status in the Super Admin console;
  // only the shell-native Approvals page has a build flag.
  approvalsEnabled: false,
  // Advanced dashboard widgets (content + custom) are deferred for beta —
  // content lacks an editor; custom (api-widget/custom-code) is unsafe.
  dashboardAdvancedWidgetsEnabled: false,
  // No live compliance claims until Klaro is actually certified.
  complianceCertified: false,
  // Real Activity feed — ON for deployed dev, where the audit read API ships first.
  activityFeedEnabled: true,

  // Microsoft Clarity — ON for deployed dev so the frontend can be validated.
  // Set strict masking + disable ad data-sharing in the Clarity dashboard.
  clarity: { enabled: true, projectId: 'y8uecii6nw' },

  // Platform apex. Subdomain tenancy is CANCELLED (this reverts PR #451's
  // dev.hiklaro.com apex flip): under PATH-based tenancy a workspace lives at
  // klaro-business-dev.hiklaro.com/{slug}, and this value only feeds display
  // fallbacks and the platform-host builder (klaro-business-dev.<apex>) —
  // both of which need the bare apex.
  tenantDomain: 'hiklaro.com',

  // Path-based workspace routing (first path segment = tenant slug).
  tenantRoutingEnabled: true,

  authServiceUrl: 'https://api.hiklaro.com/dev/klaro-auth',
  masterServiceUrl: 'https://api.hiklaro.com/dev/klaro-master',
  appCenterServiceUrl: 'https://api.hiklaro.com/dev/klaro-appcenter',
  menuServiceUrl: 'https://api.hiklaro.com/dev/klaro-menu',
  subscriptionServiceUrl: 'https://api.hiklaro.com/dev/klaro-subscription',
  iamServiceUrl: 'https://api.hiklaro.com/dev/klaro-iam',
  notificationServiceUrl: 'https://api.hiklaro.com/dev/klaro-notification',
  organizationServiceUrl: 'https://api.hiklaro.com/dev/klaro-organization',
  userServiceUrl: 'https://api.hiklaro.com/dev/klaro-user',
  chatServiceUrl: 'https://api.hiklaro.com/dev/klaro-chat',
  callServiceUrl: 'https://api.hiklaro.com/dev/klaro-call',
  calendarServiceUrl: 'https://api.hiklaro.com/dev/klaro-calendar',
  emailServiceUrl: 'https://api.hiklaro.com/dev/klaro-email',
  driveServiceUrl: 'https://api.hiklaro.com/dev/klaro-storage',
  workspaceAiUrl: 'https://api.hiklaro.com/dev/klaro-digital-workspace-be',
  workspaceAiStreaming: true,
  searchServiceUrl: 'https://api.hiklaro.com/dev/klaro-search',
};
